export const LIMIT_CUSTOM_TAG_COLUMN = 5;
